// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Poppins_da753f', '__Poppins_Fallback_da753f'","fontStyle":"normal"},"className":"__className_da753f","variable":"__variable_da753f"};